import { createSlice } from "@reduxjs/toolkit";
import { triggerWelcomeEmailAPI } from "../../services/triggerWelcomeEmail";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const triggerWelcomeEmailSlice = createSlice({
  name: "triggerWelcome",
  initialState: data,
  reducers: {
    triggerWelcomeInfo(state) {
      state.isLoading = true;
    },
    triggerWelcomeSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    triggerWelcomeFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    triggerWelcomeReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const triggerWelcomeEmailHandler =
  (data, options = {}) =>
  async (dispatch) => {
  try {
    dispatch(triggerWelcomeEmailAction.triggerWelcomeInfo());
    const response = await triggerWelcomeEmailAPI(data, options);
    dispatch(triggerWelcomeEmailAction.triggerWelcomeSuccess(response));
  } catch (e) {
    const failurePayload =
      e && typeof e === "object" && "message" in e
        ? e
        : { message: e || "Something went wrong." };
    dispatch(triggerWelcomeEmailAction.triggerWelcomeFailure(failurePayload));
  }
};
export default triggerWelcomeEmailSlice.reducer;
export const triggerWelcomeEmailAction = triggerWelcomeEmailSlice.actions;
